import { Props, getImageUrls } from './images';

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const SearchCategory: React.FC<Props> = props => {
    const { fallBack, image, encodedImage, name } = getImageUrls(props, 'Categories');
    const [validSrc, setValidSrc] = React.useState<string>((name?.includes('/') ? encodedImage : image) ?? fallBack ?? '');
    const ref = React.useRef<Msdyn365.Image>(null);

    const testImage = React.useCallback((src: string): Promise<boolean> => {
        return new Promise(resolve => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = src;
        });
    }, []);

    const applyFallbacks = React.useCallback(async () => {
        if (encodedImage && (await testImage(encodedImage))) {
            setValidSrc(encodedImage);
            return;
        }
        setValidSrc(fallBack ?? '');
    }, []);

    React.useEffect(() => {
        if (ref.current) {
            ref.current.onMainImageUpdate = ({ src, loadFailed }) => {
                if (loadFailed || (fallBack && src.includes(fallBack))) {
                    void applyFallbacks();
                }
            };
        }
    }, [image, encodedImage, fallBack]);

    return (
        <a className='search-category' href={props.url} data-webgroup-id={props.WebGroupId}>
            <span className='image-wrapper'>
                <Msdyn365.Image gridSettings={{}} ref={ref} imageFallbackOptimize src={validSrc} />
            </span>
            <span className='product-name'>{props.title}</span>
        </a>
    );
};
